// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Create: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve" fill="currentColor">
<path d="M23.89,6.62c0-0.44-0.17-0.86-0.49-1.18l-4.78-4.78c-0.63-0.63-1.73-0.63-2.36,0l-3.41,3.41l0.01,0.01l-9.41,9.41L0.11,23.8
	l10.57-3.15l9.82-9.93l-0.01-0.01l2.9-2.9C23.72,7.49,23.89,7.07,23.89,6.62z M9.12,16.59H7.36v-1.79l7.61-7.64l1.87,1.87
	L9.12,16.59z M6.47,13.72l-1.01-0.23l7.92-7.92l0.6,0.6L6.47,13.72z M4.54,14.71l1.42,0.32v2.96h2.91l0.46,1.6L2.27,21.7L4.54,14.71
	z M10.56,18.79l-0.37-1.28l7.65-7.48l0.7,0.7L10.56,18.79z M22.41,6.81l-2.9,2.9l-5.15-5.15l2.9-2.9c0.1-0.1,0.27-0.1,0.38,0
	l4.78,4.78C22.52,6.54,22.52,6.71,22.41,6.81z"/>
</svg>;
};

export default React.memo(Create);
